import PageStyle from "@/styles/components/request-for-more/_index.module.scss";
import { CommonAction } from "@/actions/common/common";
import { InfoModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
import { useTranslation } from '@/imports-files/common/common';
export function ScheduleDetails({ setBtnPopup, meetingDetails }) {
  const commonAction = new CommonAction();
  const {t} = useTranslation()
  return (
    <div className={`${InfoModalStyle.ModalOverlay}`}>
      <div className={`${InfoModalStyle.Modal}`} style={{minHeight:"auto"}} >
        <div className={`${InfoModalStyle.Modal__Container}`}>
        <div className={`${InfoModalStyle.Modal__Container__Heading__Close}`}>
          <h1 className={`${InfoModalStyle.Modal__Container__ContentSection__Heading}`} >{t('modal:form:import:previous_job:interview_details')}</h1>
          <div
            className={`${InfoModalStyle.Modal__Container__CloseSection}`}
            onClick={() => setBtnPopup(false)}>
            <Close />
          </div>
        </div>
          <div className={`${InfoModalStyle.Modal__Container__ContentSection} mt20`}>
              <h6 className={`${InfoModalStyle.Modal__Container__ContentSection__Description}`} style={{height:"auto"}} >{meetingDetails.details.message}</h6>
              {meetingDetails.details.round_details.map((round, index) => {
                return (
                  <h6 className={`${InfoModalStyle.Modal__Container__ContentSection__Description}`} style={{height:"auto"}} >
                    <b>{t('label:round')} {index + 1} </b> {round.time} <b>{t('label:with')}</b>{" "}
                    {round.member_names}.{" "}
                    {round.meeting_link && (
                      <a
                        href={commonAction.embedHttps(round.meeting_link)}
                        target="_blank"
                        style={{ textDecoration: "underline" }}
                      >
                        <b>Meeting Link</b>
                      </a>
                    )}
                  </h6>
                );
              })}
            </div>
        </div>
      </div>
    </div>
  );
}
